/* eslint-disable no-unused-vars */
export enum EOrderStatus {
  APPROVED = "APPROVED",
  APPROVAL_NEEDED = "APPROVAL_NEEDED",
  CANCELED = "CANCELED",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  SHIPPED = "SHIPPED",
  COMPLETED = "COMPLETED",
  TRIAGED = "TRIAGED",
}

export interface IOrderItemResponse {
  id: string;
  productName: string;
  petId: string;
  petName: string;
  quantity: number;
  price: number;
  imageUrl: string;
  productUrl: string;
}

export interface IOrderResponse {
  id: string;
  orderNumber: string;
  orderDate: string;
  status: string;
  items: IOrderItemResponse[];
  subtotal: number;
  tax: number;
  shippingFee: number;
  trackingNumber: string;
  vetCoveUrl: string;
}

export interface IGetOrdersResponse {
  getOnlinePharmacyOrders: {
    subscriptionsUrl: string;
    ordersUrl: string;
    orders: IOrderResponse[];
    hasMore: boolean;
    pageNumber: number;
    totalCount: number;
    pageSize: number;
  };
}

export interface IMappedOrderItem {
  id: string;
  name: string;
  petId: string;
  petName: string;
  price: string;
  quantity: number;
  productUrl: string;
  imageUrl: string;
}

export interface IMappedOrder {
  id: string;
  orderNumber: string;
  status: EOrderStatus;
  date: string;
  total: string;
  items: IMappedOrderItem[];
  trackingNumber: string | null;
  vetCoveUrl: string;
}

export interface IMappedSummary {
  totalOrders: number;
  inTransit: number;
  totalSpent: string;
}
